import React from "react";
import { Modal, Typography, Table, Card, Row, Col, Image } from "antd";

const { Title, Text } = Typography;

const OrderDetailsModal = ({ visible, order, staffData, onCancel }) => {
  const [modalWidth, setModalWidth] = React.useState(1200); // Adjust modal width as needed

  const columns = [
    {
      title: "Product Id",
      dataIndex: "product_id",
      key: "product_id",
    },
    {
      title: "Product Name",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "Total Quantity Sold",
      dataIndex: "total_quantity_sold",
      key: "total_quantity_sold",
      render: (text) => `${text}`,
    },

    {
      title: "Product Image",
      dataIndex: "product_image_url",
      key: "product_image_url",
      render: (text) => (
        <Image src={text} alt="Product" style={{ width: 100 }} />
      ),
    },
  ];

  return (
    <Modal
      title=""
      visible={visible}
      onCancel={onCancel}
      width={modalWidth}
      footer={null} // No footer buttons
    >
      <Row gutter={[16, 16]}>
        {/* Order Information Card */}

        {/* Order Items Card */}
        <Col span={24}>
          <Card title="Vendor Products" bordered={false}>
            <Table columns={columns} dataSource={order} rowKey="product_id" />
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default OrderDetailsModal;
